import { render, staticRenderFns } from "./landing.component.vue?vue&type=template&id=3592420e&scoped=true&"
import script from "./landing.component.ts?vue&type=script&lang=ts&"
export * from "./landing.component.ts?vue&type=script&lang=ts&"
import style0 from "./landing.component.scss?vue&type=style&index=0&id=3592420e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592420e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
